import { anyOf, objectOf } from "@altostra/type-validations";
import { nullOrUndefined, string } from "@altostra/type-validations/lib/primitives";

// Null on a deployment where Workload Identity Federation is not configured.
const maybeNullString = anyOf(nullOrUndefined, string);

export const isGetIntegrationsDirectCdiSnowflakeWifPrincipalAppGroupIdResult = objectOf({
  snowflake_wif_principal: maybeNullString,
});
